import { useCallback } from 'react';
import { eventMomentFactory } from '../../../../data/misc/eventMomentFactory';
import { useUserSchedule } from '../../../../data/hooks/schedule/useUserSchedule';
import { DATE_FORMAT_URL } from '../../../../data/constants/datetime';

export function useOtherSessions(event, session) {
    const date = eventMomentFactory(event, session?.start_local).format(DATE_FORMAT_URL),
        filter = useCallback((session) => session.is_selected && eventMomentFactory(event, session.start_local).format(DATE_FORMAT_URL) == date, [date]),
        result = useUserSchedule(event?.id, {
            filter,
        });

    return result;
}
